var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"server-message"},[_c('snackbar',{attrs:{"timeout":1000 * 20,"snack-bar-type":_vm.snackBarType,"snackbar-value":_vm.showMessage},on:{"close":_vm.closeSnackbar}},[_vm._v(" "+_vm._s(_vm.message)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }